import type { CustomPackagesExportRequest, CustomPackagesExportResult } from './custom-packages-export.types';

export const EXPORT_CUSTOM_PACKAGES_REQUEST = 'EXPORT_CUSTOM_PACKAGES_REQUEST';
export const exportCustomPackages = (data: CustomPackagesExportRequest) => ({
  type: EXPORT_CUSTOM_PACKAGES_REQUEST,
  data,
});

export const EXPORT_CUSTOM_PACKAGES_ASYNC_SUCCESS = 'EXPORT_CUSTOM_PACKAGES_ASYNC_SUCCESS';
export const exportCustomPackagesAsyncSuccess = (messageGuid: string, data: CustomPackagesExportResult) => ({
  type: EXPORT_CUSTOM_PACKAGES_ASYNC_SUCCESS,
  data,
  messageGuid,
});
